import { Grid, InputLabel } from '@material-ui/core';

import { SingleFieldContactInput, TextInput } from '@room-match/shared-ui-components';

import { Column, Heading, TwoOneColumn, useStyles } from '../BillingInformation.styles';

import { Autocomplete } from '@material-ui/lab';
import { getIn } from 'formik';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { googleMapsService } from 'shared/services/googleMapsService';
import { mappedCity, mappedCountry, mappedState } from 'shared/utils/countryStateMapper';
import { getErrorMessage } from 'shared/utils/room-shared';

type Props = {
  form: any;
};

const { getCountries, getStatesByCountry, getCitiesByStateAndCountry } = countryStateApiService();
const { geolocate } = googleMapsService();

const Individual: React.FC<Props> = ({ form }) => {
  const classes = useStyles();
  const { data: countriesData } = getCountries();
  const { data: statesData } = getStatesByCountry(form.values.billing_information.personal_information.country || '', {
    enabled: !!form.values.billing_information.personal_information.country,
  });

  const { data: citiesData } = getCitiesByStateAndCountry(
    form.values.billing_information.personal_information.country || '',
    form.values.billing_information.personal_information.state || '',
    {
      enabled:
        !!form.values.billing_information.personal_information.country &&
        !!form.values.billing_information.personal_information.state,
    },
  );
  return (
    <Grid item>
      <Heading>Personal Information</Heading>
      <TwoOneColumn>
        <div>
          <div>
            <TextInput
              label={'First Name *'}
              placeholder="First name…"
              name="billing_information.personal_information.first_name"
              value={form.values.billing_information.personal_information.first_name}
              InputProps={{
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              onChange={(e) => {
                const { value } = e.target as { value: string };
                form.setFieldValue(`billing_information.personal_information.first_name`, value);
              }}
            />
          </div>
          <div>
            <TextInput
              label={'Last Name *'}
              placeholder="Last name…"
              name="billing_information.personal_information.last_name"
              value={form.values.billing_information.personal_information.last_name}
              InputProps={{
                classes: {
                  root: classes.textInputStyle,
                },
              }}
              onChange={(e) => {
                const { value } = e.target as { value: string };
                form.setFieldValue(`billing_information.personal_information.last_name`, value);
              }}
            />
          </div>
        </div>
        <div>
          <TextInput
            label={'Address'}
            placeholder="Type address…"
            name="billing_information.personal_information.address"
            value={form.values.billing_information.personal_information.address}
            InputProps={{
              classes: {
                root: classes.textInputStyle,
              },
            }}
            onChange={(e) => {
              const { value } = e.target as { value: string };
              form.setFieldValue(`billing_information.personal_information.address`, value);
            }}
          />
        </div>
      </TwoOneColumn>
      <Column>
        <Grid item lg={3} md={3} xs={12}>
          <TextInput
            label={'Zip Code'}
            placeholder="Enter zip code…"
            name="billing_information.personal_information.zip_code"
            value={form.values.billing_information.personal_information.zip_code}
            InputProps={{
              classes: {
                root: classes.textInputStyle,
              },
            }}
            onChange={(e) => {
              const { value } = e.target as { value: string };
              form.setFieldValue(`billing_information.personal_information.zip_code`, value);
            }}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <Autocomplete
            options={mappedCity(citiesData || [])}
            clearOnBlur={false}
            getOptionLabel={(option) => option.key}
            classes={{ option: classes.option }}
            fullWidth
            getOptionSelected={(options, values) => options.value === values.value}
            value={{
              value: form.values.billing_information.personal_information.city || '',
              key:
                mappedCity(citiesData || []).find(
                  (v) => v.value === form.values.billing_information.personal_information.city,
                )?.key || '',
            }}
            onChange={(e, record, reason) => {
              if (record) {
                if (reason === 'clear') {
                  return form.setFieldValue('billing_information.personal_information.city', '');
                } else if (reason === 'select-option') {
                  return form.setFieldValue('billing_information.personal_information.city', record.value);
                }
              }
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                type="text"
                variant="outlined"
                errorMessage={getErrorMessage(
                  getIn(form.touched, `billing_information.personal_information.city`),
                  getIn(form.errors, `billing_information.personal_information.city`),
                )}
                autoComplete="none"
                value={form.values.billing_information.personal_information.city}
                name="billing_information.personal_information.city"
                onBlur={form.handleBlur}
                label="Working City"
                placeholder="Select Working City"
                inputProps={{
                  ...params.inputProps,
                  autocomplete: 'none',
                  form: {
                    autocomplete: 'none',
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <Autocomplete
            options={mappedState(statesData || [])}
            clearOnBlur={false}
            getOptionLabel={(option) => option.key}
            fullWidth
            classes={{ option: classes.option }}
            getOptionSelected={(options, values) => options.value === values.value}
            value={{
              value: form.values.state_code || '',
              key:
                mappedState(statesData || []).find(
                  (v) => v.value === form.values.billing_information.personal_information.state,
                )?.key || '',
            }}
            onChange={(e, record, reason) => {
              if (record) {
                if (reason === 'clear') {
                  form.setFieldValue('billing_information.personal_information.city', '');
                  return form.setFieldValue('billing_information.personal_information.state', '');
                } else if (reason === 'select-option') {
                  form.setFieldValue('billing_information.personal_information.city', '');
                  return form.setFieldValue('billing_information.personal_information.state', record.value);
                }
              }
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                type="text"
                variant="outlined"
                errorMessage={getErrorMessage(
                  getIn(form.touched, `billing_information.personal_information.state`),
                  getIn(form.errors, `billing_information.personal_information.state`),
                )}
                autoComplete="none"
                value={form.values.billing_information.personal_information.state}
                name="billing_information.personal_information.state"
                label="State"
                placeholder="Select State"
                onBlur={form.handleBlur}
                inputProps={{
                  ...params.inputProps,
                  autocomplete: 'none',
                  form: {
                    autocomplete: 'none',
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item lg={3} md={3} xs={12}>
          <Autocomplete
            options={mappedCountry(countriesData || [])}
            getOptionLabel={(option) => option.key}
            fullWidth
            classes={{ option: classes.option }}
            getOptionSelected={(options, value) =>
              options.value === form.values.billing_information.personal_information.country
            }
            value={{
              value: form.values.billing_information.personal_information.country
                ? form.values.billing_information.personal_information.country
                : 'us',
              key:
                mappedCountry(countriesData || []).find(
                  (v) => v.value === form.values.billing_information.personal_information.country,
                )?.key || 'United States',
            }}
            onChange={(e, record) => {
              if (record) {
                form.setFieldValue('billing_information.personal_information.state', '');
                form.setFieldValue('billing_information.personal_information.city', '');
                form.setFieldValue('billing_information.personal_information.zip_code', '');
                return form.setFieldValue('billing_information.personal_information.country', record.value);
              }
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                type="text"
                variant="outlined"
                label="Country"
                errorMessage={getErrorMessage(
                  getIn(form.touched, `billing_information.personal_information.country`),
                  getIn(form.errors, `billing_information.personal_information.country`),
                )}
                autoComplete="none"
                value={form.values.billing_information.personal_information.country}
                name="billing_information.personal_information.country"
                placeholder="Select Country"
                onBlur={form.handleBlur}
                inputProps={{
                  ...params.inputProps,
                  autocomplete: 'none',

                  form: {
                    autocomplete: 'none',
                  },
                }}
              />
            )}
          />
        </Grid>
      </Column>
      <TwoOneColumn style={{ gap: 0 }}>
        <div style={{ gap: 0 }}>
          <div>
            <InputLabel id="contactNumber" style={{ marginBottom: '-15px' }}>
              Phone Number
            </InputLabel>
            <SingleFieldContactInput
              country={form.values.billing_information.personal_information.phone_country_code}
              inputValue={form.values.billing_information.personal_information.phone_number}
              onChange={(value, data) => {
                form.setFieldValue(`billing_information.personal_information.phone_country_code`, data.countryCode);
                form.setFieldValue(`billing_information.personal_information.phone_number`, value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div></div>
      </TwoOneColumn>
    </Grid>
  );
};

export default Individual;
